import { insertNewRow } from "../insertRows";
import * as z from "zod";
import { PERSONAL_CHAT_NAME_MAX_LENGTH } from "../personalChatName";
import { assertPersonalWorkEnabled } from "../personalWorkGuard";
import { mutator } from "./mutator";
import { clientGeneratableIdSchema } from "../id";

export const DEFAULT_PERSONAL_CHAT_NAME = "Untitled";

export const createPersonalChatSchema = z.object({
  id: clientGeneratableIdSchema,
  chatId: clientGeneratableIdSchema,
  name: z.string().trim().min(1).max(PERSONAL_CHAT_NAME_MAX_LENGTH).optional(),
});

export const createPersonalChat = mutator({
  schema: createPersonalChatSchema,
  resolve: {},
  permissions: {
    none: "creates a fresh chat and a personal-chat row owned by ctx.userId",
  },
  fn: async ({ tx, ctx, args }) => {
    await assertPersonalWorkEnabled(tx, ctx.tenantId);
    const { id, chatId } = args;
    const { userId } = ctx;
    const now = Date.now();

    await insertNewRow(tx, "chats", {
      id: chatId,
      commitId: null,
      createdAt: now,
      tenantId: ctx.tenantId,
    });

    await insertNewRow(tx, "personalChats", {
      id,
      chatId,
      userId,
      name: args.name ?? DEFAULT_PERSONAL_CHAT_NAME,
      userChangedNameAt: null,
      preserveLegacyName: false,
      nameCheckedThrough: null,
      deletedAt: null,
      createdAt: now,
      lastActiveAt: now,
      tenantId: ctx.tenantId,
    });
  },
});
